<template>
    <div class="mx-auto">
        <b-row class="mb-0">
            <b-col md="6" class="mb-0" style="border-right: 1px solid black;">
                <b-row class="mb-4">
                    <b>Migrar Processo(s):</b>
                </b-row>
                <b-row class="mb-0">
                    <b>Pesquisa pelo número do Processo:</b>
                    <i class="fa fa-info-circle fa-12x text-info ml-2" variant="info"
                        v-b-popover.hover.top="'Utilize esse campo para pesquisar um determinado número de processo.'">
                    </i>
                </b-row>
                <b-row>
                    <b-col sm="12" md="4">
                        <b-form-group label="Informe o número do Processo:" label-for="cnj" ref="cnj"
                            :class="'text-label ' + (!validations.cnj.valid ? 'is-invalid' : '')">
                            <b-form-input type="text" id="cnj1" v-model="filtros.cnj" autofocus
                                v-mask="['#######-##.####.#.##.####']" description="Somente os números"
                                @change="preencherCnjComZerosEsquerda1()"
                                @blur="falsoClick1()" @focus="limparEdicao()"
                                :class="'text-label required ' + (!validations.cnj.valid ? 'is-invalid' : '')">
                            </b-form-input>
                            <div v-if="!validations.cnj.valid" class="invalid-message">
                                {{ validations.cnj.message }}
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>

                <hr class="mt-4" />

                <b-row class="mb-0">
                    <b>Pesquisa por Devedor:</b>
                    <i class="fa fa-info-circle fa-12x text-info ml-2" variant="info"
                        v-b-popover.hover.top="'Utilize esse campo para pesquisar os registros de protesto e ajuizamento de CDAs de um determinado devedor.'">
                    </i>
                </b-row>
                <b-row>
                    <b-col md="4">
                        <b-form-group label="Informe o CPF / CNPJ / Raiz CNPJ:" label-for="cpf"
                            :class="'text-label ' + (!validations.cpfCnpj.valid ? 'is-invalid' : '')">
                            <b-form-input type="text" ref="numDocumento" id="num-documento" data-vv-as="CPF"
                                v-model="filtros.cpfCnpj"
                                v-mask="['XX.XXX.XXX', 'XXX.XXX.XXX-XX', 'XX.XXX.XXX/XXXX-##']" @change="buscarDevedor"
                                :class="'text-label required ' + (!validations.cpfCnpj.valid ? 'is-invalid' : '')">
                            </b-form-input>
                            <div v-if="!validations.cpfCnpj.valid" class="invalid-message">
                                {{ validations.cpfCnpj.message }}
                            </div>
                        </b-form-group>
                    </b-col>
                    <b-col md="8">
                        <b-form-group label="Nome / Razão Social do Devedor:" label-for="devedor"
                            :class="'text-label ' + (!validations.nome.valid ? 'is-invalid' : '')">
                            <vue-suggestion :items="devedores" v-model="filtros.nomeDevedor" :setLabel="setLabel"
                                :itemTemplate="itemTemplate" :inputClasses="'form-control'" :minLen="3"
                                @changed="inputChange" @blur="inputBlur" @selected="itemSelected" @enter="acaoEnter"
                                :class="'text-label required ' + (!validations.nome.valid ? 'is-invalid' : '')">
                            </vue-suggestion>
                            <div v-if="!validations.nome.valid" class="invalid-message">
                                {{ validations.nome.message }}
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>

                <hr class="mt-4" />

                <b-row class="mb-0">
                    <b>Pesquisa CDAs ajuizadas num período determinado:</b>
                    <i class="fa fa-info-circle fa-12x text-info ml-2" variant="info"
                        v-b-popover.hover.top="'Utilize esse campo para pesquisar os registros de ajuizamento de CDAs realizados num determinado período e de devedores diversos.'">
                    </i>
                </b-row>
                <b-row>
                    <b-col md="6">
                        <label>
                            Informe a data de início:
                        </label>
                        <b-input v-model="filtros.dataInicio" type="date" placeholder
                            :class="'text-label required ' + (!validations.dataInicio.valid ? 'is-invalid' : '')">
                            <div v-if="!validations.dataInicio.valid" class="invalid-message">
                                {{ validations.dataInicio.message }}
                            </div>
                        </b-input>
                    </b-col>
                    <b-col md="6">
                        <label>
                            Informe a data de fim:
                        </label>
                        <b-input v-model="filtros.dataFinal" type="date" placeholder
                            :class="'text-label required ' + (!validations.dataFinal.valid ? 'is-invalid' : '')">
                            <div v-if="!validations.dataFinal.valid" class="invalid-message">
                                {{ validations.dataFinal.message }}
                            </div>
                        </b-input>
                    </b-col>
                </b-row>
            </b-col>
            <!-- TODO input -->
            <b-col md="6" class="mb-0" style="padding-left: 40px;">
                <b-row class="mb-4">
                    <b>Editar Processo já migrado:</b>
                </b-row>
                <b-row class="mb-0">
                    <b>Processo a ser editado:</b>
                </b-row>
                <b-row>
                    <b-col sm="12" md="4">
                        <b-form-group label="Informe o número do Processo" label-for="cnj" ref="cnj" class="text-label"
                            :class="'text-label ' + (!validations.cnjEdicao.valid ? 'is-invalid' : '')">
                            <b-form-input type="text" id="cnj2" v-model="filtros.cnjEdicao"
                                v-mask="['#######-##.####.#.##.####']" description="Somente os números"
                                @change="preencherCnjComZerosEsquerda2()"
                                @blur="falsoClick2()" @focus="limparFiltros()"
                                :class="'text-label required ' + (!validations.cnjEdicao.valid ? 'is-invalid' : '')">
                            </b-form-input>
                            <div v-if="!validations.cnjEdicao.valid" class="invalid-message">
                                {{ validations.cnjEdicao.message }}
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>

    </div>
</template>

<script>
import axios from 'axios';
import formatarMixins from '../../../mixins/formatarMixins';
import itemTemplate from './item-template.vue';
import validacoesUtil from '../../../util/validacoesUtil';
export default {
    props: ['filtros', 'validations'],
    mixins: [formatarMixins],
    data() {
        return {
            urlApi: null,
            token: null,
            itemTemplate: itemTemplate,
            timer: null,
            devedores: []
        }
    },
    methods: {
        itemSelected(item) {
            this.filtros.nomeDevedor = item.nome;
            this.filtros.cpfCnpj = item.cpfCnpjString;
        },
        inputBlur(item) {
            this.filtros.nomeDevedor = { nome: item };
        },
        setLabel(item) {
            return item.nome;
        },
        inputChange(text) {
            if (text != null && text.length >= 3) {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    let devedor = {
                        nome: text
                    };

                    axios.post(`${this.urlApi}/v1/processosDigitalizados/listarDevedorSiproPorNome`, devedor, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        }
                    }).then(response => {
                        this.devedores = response.data;
                    })
                }, 800);
            }
        },
        async buscarDevedor() {
            validacoesUtil.limparValidacao(this.validations);
            if (this.filtros.cpfCnpj != null && this.filtros.cpfCnpj.length > 0) {
                this.$store.commit("setMessages", {});
                this.filtros.nomeDevedor = { id: 0, nome: '' };

                if (this.filtros.cpfCnpj.length == 10) {
                    return;
                } else if (this.filtros.cpfCnpj.length <= 14 && !this.validarCpf(this.filtros.cpfCnpj)) {
                    validacoesUtil.adicionarErroDeValidacao(this.validations.cpfCnpj, 'CPF inválido.');
                    return;
                } else if (this.filtros.cpfCnpj.length > 14 && !this.validarCNPJAlfanumerico(this.filtros.cpfCnpj)) {
                    validacoesUtil.adicionarErroDeValidacao(this.validations.cpfCnpj, 'CNPJ inválido.');
                    return;
                }

                let devedor = {
                    cpfCnpj: this.filtros.cpfCnpj
                };

                axios.post(`${this.urlApi}/v1/processosDigitalizados/obterNomeDevedorSipro`, devedor, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    if (response.data != null && response.data != "") {
                        this.filtros.nomeDevedor = { id: 0, nome: response.data };
                    }
                }).finally(() => {
                });
            }
        },

        acaoEnter() {
            document.getElementById("btnProxima").click();
        },

        limparEdicao() {
            this.filtros.cnjEdicao = null;
            validacoesUtil.limparValidacao(this.validations);
        },

        limparFiltros() {
            this.filtros.cnj = null;
            this.filtros.cpfCnpj = null;
            this.filtros.dataInicio = null;
            this.filtros.dataFinal = null;
            this.filtros.nomeDevedor = { id: 0, nome: null };
            validacoesUtil.limparValidacao(this.validations);
        },

        validarCnj(cnj, cnjDentroDoValidations) {
           validacoesUtil.limparValidacao(this.validations);
            if (cnj != null && cnj != "" && (cnj.length < 25 || !this.validaCnj(cnj))) {
                validacoesUtil.adicionarErroDeValidacao(cnjDentroDoValidations, 'CNJ inválido.');
            }
        },

        validarCnjEdicao(cnj, cnjDentroDoValidations) {
           validacoesUtil.limparValidacao(this.validations);
            if (cnj != null && cnj != "" && (cnj.length < 25 || !this.validaCnj(cnj))) {
                validacoesUtil.adicionarErroDeValidacao(cnjDentroDoValidations, 'Processo inexistente na base do PROAJU ou número inválido.');
            }
        },

        preencherCnjComZerosEsquerda1() {
            this.preencherCnjComZerosEsquerda("cnj1",  this.validations.cnj);
        },

        preencherCnjComZerosEsquerda2() {
            this.preencherCnjComZerosEsquerda("cnj2",  this.validations.cnjEdicao);
        },

        preencherCnjComZerosEsquerda(id, cnjDentroDoValidations) {
            let element = document.getElementById(id);
            if (element.value != null && element.value != '') {
                let tamanho = element.value.replace(/[^0-9]/g, '').replace(/(\*)\./g, '$1').length;
                if (22 > tamanho) {
                    element.value = Array(21 - tamanho).join('0') + element.value
                }
            }
            if(id == 'cnj1') {
                this.validarCnj(element.value, cnjDentroDoValidations);
            } else {
                this.validarCnjEdicao(element.value, cnjDentroDoValidations);
            }
        },

        falsoClick(id) {
            document.getElementById(id).blur();
        },

        falsoClick1() {
            this.falsoClick("cnj1");
        },

        falsoClick2() {
            this.falsoClick("cnj2");
        },

    },
    mounted() {
        this.$store.commit("setMessages", {});
        this.urlApi = process.env.VUE_APP_ROOT_API;
        this.token = JSON.parse(this.$store.getters.getUser).access_token;

        setTimeout(() => {
            this.$refs['cnj'].$el.focus();
        }, 500);

        window.addEventListener("keypress", function (e) {
            if (e.key == 'Enter') {
                document.getElementById("btnProxima").click();
            }
        });
    }
}
</script>